import dataApi from '../'

export default {

  /**
   * Get unit roles overview
   */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit-roles/overview',
      params: params
    })
  },
   /**
  * Get unit roles based on a search value
  */
  getSearch (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit-roles/search',
      params: params
    })
  },
  /**
   * Get unit role by uuid
   */
  getUnitRole (id) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit-roles/info-for-edit?id=' + id
    })
  },
  /**
   * Get unit role permissions by org uuid
   */
  getPermissions () {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit-roles/permissions'
    })
  },
   /**
  * Add unit role
  */
  postAdd (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/unit-roles/create',
      body: params
    })
  },

  /**
  * Edit unit role
  */
  putEdit (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/unit-roles/edit',
      body: params
    })
  },

   /**
  * Delete unit
  */
  deleteDelete (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/unit-roles/delete',
      params: params
    })
  },

  /**
  * Get unit roles for selected organization
  */
  getUnitRolesByOrgUuid (uuid) {
    return dataApi.request({
      method: 'get',
      url: 'ui/unit-roles/by-organization?uuid=' + uuid
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/unitroles.js